import { render } from "./CoupleToolbar.vue?vue&type=template&id=1bf38aa9&scoped=true"
import script from "./CoupleToolbar.vue?vue&type=script&lang=js"
export * from "./CoupleToolbar.vue?vue&type=script&lang=js"

import "./CoupleToolbar.vue?vue&type=style&index=0&id=1bf38aa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf38aa9"]])

export default __exports__